import React from 'react';
import './MetricasCategorias.css';

function MetricasCategorias({ examen, respuestasUsuario, respuestasCorrectas, preguntasOrden }) {
  // Calcular métricas por categoría
  const calcularMetricasPorCategoria = () => {
    const metricas = {};
    
    preguntasOrden.forEach((preguntaId) => {
      const pregunta = examen.preguntas.find(p => Number(p.id) === Number(preguntaId));
      if (!pregunta) return;
      
      const categoriaNombre = pregunta.categoria?.nombre || 'General';
      
      if (!metricas[categoriaNombre]) {
        metricas[categoriaNombre] = {
          total: 0,
          correctas: 0,
          incorrectas: 0,
          porcentaje: 0
        };
      }
      
      metricas[categoriaNombre].total += 1;
      
      // Determinar si la respuesta es correcta
      const respuestaUsuario = respuestasUsuario[preguntaId];
      const respuestaCorrecta = respuestasCorrectas[preguntaId];
      
      let esCorrecta = false;
      
      if (respuestaUsuario !== undefined && respuestaUsuario !== null && respuestaCorrecta !== undefined) {
        if (Array.isArray(respuestaCorrecta)) {
          const idsUsuario = Array.isArray(respuestaUsuario) ? respuestaUsuario : [respuestaUsuario];
          const correctasSet = new Set(respuestaCorrecta);
          esCorrecta = idsUsuario.some((id) => correctasSet.has(id));
        } else if (typeof respuestaCorrecta === 'object' && respuestaCorrecta !== null) {
          if (typeof respuestaUsuario === 'object' && respuestaUsuario !== null && !Array.isArray(respuestaUsuario)) {
            let todosCorrectos = true;
            const keysCorrectas = Object.keys(respuestaCorrecta);
            if (keysCorrectas.length > 0) {
              for (const key of keysCorrectas) {
                if (respuestaUsuario[key] !== respuestaCorrecta[key]) {
                  todosCorrectos = false;
                  break;
                }
              }
              esCorrecta = todosCorrectos;
            }
          }
        } else {
          esCorrecta = respuestaUsuario === respuestaCorrecta;
        }
      }
      
      if (esCorrecta) {
        metricas[categoriaNombre].correctas += 1;
      } else {
        metricas[categoriaNombre].incorrectas += 1;
      }
    });
    
    // Calcular porcentajes
    Object.keys(metricas).forEach(categoria => {
      const m = metricas[categoria];
      m.porcentaje = m.total > 0 ? Math.round((m.correctas / m.total) * 100) : 0;
    });
    
    return metricas;
  };
  
  const metricas = calcularMetricasPorCategoria();
  const categoriasOrdenadas = Object.keys(metricas).sort();
  
  return (
    <div className="metricas-categorias-container">
      <h3 className="metricas-titulo">Results by Category</h3>
      <div className="metricas-lista">
        {categoriasOrdenadas.map((categoria) => {
          const m = metricas[categoria];
          return (
            <div key={categoria} className="metrica-item">
              <div className="metrica-header">
                <span className="metrica-categoria">{categoria}</span>
                <span className="metrica-porcentaje">{m.porcentaje}%</span>
              </div>
              <div className="metrica-bar-container">
                <div 
                  className="metrica-bar" 
                  style={{ width: `${m.porcentaje}%` }}
                ></div>
              </div>
              <div className="metrica-stats">
                <span>{m.correctas} of {m.total} correct</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MetricasCategorias;



